import React from 'react'
import { withRouter, matchPath, Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { do_action } from '../../actions'
import { setVendor } from '../../actions/index'
import ModalSignIn from '../Modal/ModalSignIn'
import {BASE_URL_ADMIN} from '../../data/config'
import { Cookies } from 'react-cookie'

const cookies = new Cookies()

class Header extends React.Component {
    constructor(props) {
        super(props);
    }

    componentWillMount() {
        let {dispatch, history} = this.props;
        const token = cookies.get('vendor');
        if (!token) {
            return history.push('/login');
        }

        if (token) do_action('get_vendor_by_token', { token })
            .then(data => {
                if (data.signal) {
                    dispatch(setVendor(data.data.vendor));
                } else {
                    cookies.remove('vendor', {path : '/', maxAge: 96969696})
                    history.push('/login');
                }
            })
            .catch(err => console.log(err));
    }

    logoutVendor(e) {
        e.preventDefault();
        let {history} = this.props;
        cookies.remove('vendor', {path : '/', maxAge: 96969696})
        history.push('/login');
    }

    renderImage(vendor) {
        if (!vendor._id) return '/images/rec1.png'
        return vendor.image ? BASE_URL_ADMIN + '/uploads/' + vendor.image : '/images/rec1.png'
    }

    rendorVendor(vendor) {
        if (!vendor._id) return ''
        if (!vendor.detail) return ''
        let {email, detail} = vendor
        detail = detail || {name: ''}
        return detail.name ? detail.name : email
    }

    renderJob(vendor) {
        if (!vendor._id) return ''
        if (vendor.type == 'contractor') return 'Contractor'
        else if (vendor.type == 'designer') return 'Designer'
        else return 'Project Manager'
    }

    render() {
        let {vendor} = this.props;
        return (
            <nav className="navbar navbar-fixed-top navbardb">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-sm-3 col-md-2 logodb">
                            <a href="#">
                                <img src="/images/ruhu-logo-14-150.png" alt="HOME" style={{width: '150px'}}/>
                            </a>
                        </div>
                        <div className="col-sm-9 col-md-10">
                            <ul className="nav navbar-nav navbar-right navbar-right-db">
                                <li className="dropdown">
                                    <a href="#" className="clearfix user" data-toggle="dropdown" role="button" aria-haspopup="true" aria-expanded="false">
                                        <div className="img">
                                            <img src={this.renderImage(vendor)} alt="" style={{width: "40px",height: "40px"}}/>
                                        </div>
                                        <div className="info">
                                            <div className="name">{this.rendorVendor(vendor)}</div>
                                            <div className="job">{this.renderJob(vendor)}</div>
                                        </div>
                                        <span className="fa fa-angle-down arrow"></span>
                                    </a>
                                    <ul className="dropdown-menu">
                                        <li><a href="#" href="/profile">My Profile</a></li>
                                        <li role="separator" className="divider"></li>
                                        <li><a href="#" onClick={this.logoutVendor.bind(this)}>Logout</a></li>
                                    </ul>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </nav>

        )
    }
}

function mapStateToProps(state) {
    const {vendor} = state
    return { vendor }
}

export default connect(mapStateToProps)(withRouter(Header))